import React from 'react';
import PropTypes from 'prop-types';
import { Progress } from 'antd';
import { ProgressText, AlertScoreWrapper } from './styled';

/**
 * ProgressBar
 * @param value {node}
 * @returns {JSX.Element}
 */
const ProgressBar = ({ value = 0, level = 'High', strokeColor }) => (
  <>
    <ProgressText>{level}</ProgressText>
    <AlertScoreWrapper>
      <ProgressText>{value}</ProgressText>
      <Progress
        percent={value}
        showInfo={false}
        size="small"
        strokeColor={strokeColor}
      />
    </AlertScoreWrapper>
  </>
);

ProgressBar.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  level: PropTypes.string,
  strokeColor: PropTypes.string
};

export default ProgressBar;
